import { render, staticRenderFns } from "./ProjectItems.vue?vue&type=template&id=819c9448&lang=pug&"
import script from "./ProjectItems.vue?vue&type=script&lang=js&"
export * from "./ProjectItems.vue?vue&type=script&lang=js&"
import style0 from "./ProjectItems.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('819c9448')) {
      api.createRecord('819c9448', component.options)
    } else {
      api.reload('819c9448', component.options)
    }
    module.hot.accept("./ProjectItems.vue?vue&type=template&id=819c9448&lang=pug&", function () {
      api.rerender('819c9448', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/projects/ProjectItems.vue"
export default component.exports